export class AppConfig {

  /*public static NT_HTTP_PROTOCOL = 'https';
  public static NT_HTTP_SEPARATOR = '://';
  public static NT_API_ENDPOINT = 'iposapi.ecare.pk/';
  public static NT_LOGIN_LOGO = 'iposapi.ecare.pk/assets/login/logo.png';
  public static NT_PROFILE_PATH = 'iposapi.ecare.pk/assets/user_profile/';
  public static NT_BASEURL = 'http://v3.nexttotal.com/';
  public static NT_ASSETS = 'iposapi.ecare.pk/assets/';
  public static NT_PAYMENT_METHODS = 'iposapi.ecare.pk/assets/img/icons/';
  public static NT_ITEM_ASSETS = 'iposapi.ecare.pk/assets/uploads/items/';
  public static NT_STORE_ASSETS = 'iposapi.ecare.pk/assets/uploads/stores/';
  public static NT_ACCESS_CLIENT = 'NextTotalClient';
  public static NT_ACCESS_SECRET = 'NextToatlSecret';*/

  // public static NT_HTTP_PROTOCOL = 'http';
  // public static NT_HTTP_SEPARATOR = '://';
  // public static NT_API_ENDPOINT = '192.168.1.136/dining/';
  // public static NT_LOGIN_LOGO = '192.168.1.136/dining/assets/login/logo.png';
  // public static NT_PROFILE_PATH = '192.168.1.136/dining/assets/user_profile/';
  // public static NT_BASEURL = 'http://localhost:4200/';
  // public static NT_ASSETS = '192.168.1.136/dining/assets/';
  // public static NT_PAYMENT_METHODS = '192.168.1.136/dining/assets/img/icons/';
  // public static NT_ITEM_ASSETS = '192.168.1.136/dining/assets/uploads/items/';
  // public static NT_STORE_ASSETS = '192.168.1.136/dining/assets/uploads/stores/';
  // public static NT_ACCESS_CLIENT = 'NextTotalClient';
  // public static NT_ACCESS_SECRET = 'NextToatlSecret';

  // public static NT_HTTP_PROTOCOL = 'http';
  // public static NT_HTTP_SEPARATOR = '://';
  // public static NT_API_ENDPOINT = '192.168.1.136/dining/';
  // public static NT_LOGIN_LOGO = '192.168.1.136/dining/assets/login/logo.png';
  // public static NT_PROFILE_PATH = '192.168.1.136/dining/assets/user_profile/';
  // public static NT_BASEURL = 'http://localhost:4200/';
  // public static NT_ASSETS = '192.168.1.136/dining/assets/';
  // public static NT_PAYMENT_METHODS = '192.168.1.136/dining/assets/img/icons/';
  // public static NT_ITEM_ASSETS = '192.168.1.136/dining/assets/uploads/items/';
  // public static NT_STORE_ASSETS = '192.168.1.136/dining/assets/uploads/stores/';
  // public static NT_ACCESS_CLIENT = 'NextTotalClient';
  // public static NT_ACCESS_SECRET = 'NextToatlSecret';

  // public static NT_HTTP_PROTOCOL = 'http';
  // public static NT_HTTP_SEPARATOR = '://';
  // public static NT_API_ENDPOINT = '122.129.79.33/gulfam/nexttotal-be/';
  // public static NT_LOGIN_LOGO = '122.129.79.33/gulfam/nexttotal-be/assets/login/logo.png';
  // public static NT_PROFILE_PATH = '122.129.79.33/gulfam/nexttotal-be/assets/user_profile/';
  // public static NT_BASEURL = 'http://v3.nexttotal.com/';
  // public static NT_ASSETS = '122.129.79.33/gulfam/nexttotal-be/assets/';
  // public static NT_PAYMENT_METHODS = '122.129.79.33/gulfam/nexttotal-be/assets/img/icons/';
  // public static NT_ITEM_ASSETS = '122.129.79.33/gulfam/nexttotal-be/assets/uploads/items/';
  // public static NT_STORE_ASSETS = '122.129.79.33/gulfam/nexttotal-be/assets/uploads/stores/';
  // public static NT_ACCESS_CLIENT = 'NextTotalClient';
  // public static NT_ACCESS_SECRET = 'NextToatlSecret';
  // public static NT_SAAS_BASEURL = '192.168.1.150:8094';
  // public static NT_SAAS_BILLING_BASEURL = '192.168.1.150:8090';
  //

  // public static NT_HTTP_PROTOCOL = 'http';
  // public static NT_HTTP_SEPARATOR = '://';
  // public static NT_API_ENDPOINT = 'localhost/NextTotalBE/';
  // public static NT_LOGIN_LOGO = 'http://localhost/NextTotalBE/assets/login/logo.png';
  // public static NT_PROFILE_PATH = 'localhost/NextTotalBE/assets/user_profile/';
  // public static NT_BASEURL = 'http://localhost:4200';
  // public static NT_ASSETS = 'localhost/NextTotalBE/assets/';
  // public static NT_PAYMENT_METHODS = 'localhost/NextTotalBE/assets/img/icons/';
  // public static NT_ITEM_ASSETS = 'localhost/NextTotalBE/assets/uploads/items/';
  // public static NT_STORE_ASSETS = 'localhost/NextTotalBE/assets/uploads/stores/';
  // public static NT_ACCESS_CLIENT = 'NextTotalClient';
  // public static NT_ACCESS_SECRET = 'NextToatlSecret';
  // public static NT_SASS_URL = 'https://accounts.rectbox.com';
  // public static NT_SAAS_BASEURL = 'saasap.rectbox.com:8080/';
  // public static NT_SAAS_BILLING_BASEURL = 'billing.rectbox.com:8080/';
  // public static NT_SAAS_PRICING_URL = 'signup.upknok.com/signup/pricing/cHJvMDA0/';
  // public static NT_STC_PAY_URL = 'https://b2btest.stcpay.com.sa/B2B.MerchantWebApi/Merchant/';
  // public static STIMULSOFT_KEY = '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHldxeRaOSLAicxGSHkNXS4CDfusF7v8nvoHRzRUGCJigeK3NK8UbqCMrn15P0uFBzdDM+rVDg6MtEHhYfuewdqJdgBPSfHgtC5vr/Lr7jyoPkzHyz4OwZdzaqeIWSxEci8sbEQpjFEBGb/e0IN6kDD8Hr3tJsjf1OoQsxQNjcGL94TDIp7+IAzLfkIqEkF23IZblF1HYCpegpXykvMBwXuFofUDDvR4wt56NzcFpl8hhysnTkCfzsx1AJSKWKUtqW4TlyOSwQWinBQcdf7novb6Fja6kUfOkfjXVutpWRBf8o56baLrQKqZn9UiovwUyWto7qbST6T6oLDHXV3JEocBTe9TQz0RW79GTgYuttKxtHUMgVUyUIbhYwZjvtur4aCFHM8srJC4mAFms88I90OS72i0mTNRJl0S0co711XZV8pef0aUcV+W40AxTyvjWvCT/rVoYrzVFJVtXLlMb54tnKPPJEJzFgzfn/p4fzP35X9RJsmwPrbLSnUQvCWplImepOVEdLH+2NYxgnSrd5zY';
  // public static AMAZON_S3 = 'https://s3.amazonaws.com/upknokpos/';


  // configration for Shafiq Working Start

  // public static NT_HTTP_PROTOCOL = 'http';
  // public static NT_HTTP_SEPARATOR = '://';
  // public static NT_API_ENDPOINT = 'localhost/backendpos/';
  // public static NT_LOGIN_LOGO = 'http://localhost/backendpos/assets/login/logo.png';
  // public static NT_PROFILE_PATH = 'localhost/backendpos/assets/user_profile/';
  // public static NT_BASEURL = 'http://localhost:4200';
  // public static NT_ASSETS = 'localhost/backendpos/assets/';
  // public static NT_PAYMENT_METHODS = 'localhost/backendpos/assets/img/icons/';
  // public static NT_ITEM_ASSETS = 'localhost/backendpos/assets/uploads/items/';
  // public static NT_STORE_ASSETS = 'http://localhost/backendpos/assets/uploads/stores/';
  // public static NT_ACCESS_CLIENT = 'NextTotalClient';
  // public static NT_ACCESS_SECRET = 'NextToatlSecret';
  // public static NT_SASS_URL = 'https://accounts.rectbox.com';
  // public static NT_SAAS_BASEURL = 'saasap.rectbox.com:8080/';
  // public static NT_SAAS_BILLING_BASEURL = 'billing.rectbox.com:8080/';
  // public static NT_SAAS_PRICING_URL = 'signup.upknok.com/signup/pricing/cHJvMDA0/';
  // public static NT_STC_PAY_URL = 'https://b2btest.stcpay.com.sa/B2B.MerchantWebApi/Merchant/';
  // public static STIMULSOFT_KEY = '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHldxeRaOSLAicxGSHkNXS4CDfusF7v8nvoHRzRUGCJigeK3NK8UbqCMrn15P0uFBzdDM+rVDg6MtEHhYfuewdqJdgBPSfHgtC5vr/Lr7jyoPkzHyz4OwZdzaqeIWSxEci8sbEQpjFEBGb/e0IN6kDD8Hr3tJsjf1OoQsxQNjcGL94TDIp7+IAzLfkIqEkF23IZblF1HYCpegpXykvMBwXuFofUDDvR4wt56NzcFpl8hhysnTkCfzsx1AJSKWKUtqW4TlyOSwQWinBQcdf7novb6Fja6kUfOkfjXVutpWRBf8o56baLrQKqZn9UiovwUyWto7qbST6T6oLDHXV3JEocBTe9TQz0RW79GTgYuttKxtHUMgVUyUIbhYwZjvtur4aCFHM8srJC4mAFms88I90OS72i0mTNRJl0S0co711XZV8pef0aUcV+W40AxTyvjWvCT/rVoYrzVFJVtXLlMb54tnKPPJEJzFgzfn/p4fzP35X9RJsmwPrbLSnUQvCWplImepOVEdLH+2NYxgnSrd5zY';
  // public static AMAZON_S3 = 'https://s3.amazonaws.com/upknokpos/';



  public static NT_HTTP_PROTOCOL = 'https';
  public static NT_HTTP_SEPARATOR = '://';
  public static NT_API_ENDPOINT = 'ipos.quickxero.com/backendpos/';
  public static NT_LOGIN_LOGO = 'https://ipos.quickxero.com/backendpos/assets/login/logo.png';
  public static NT_PROFILE_PATH = 'ipos.quickxero.com/backendpos/assets/user_profile/';
  public static NT_BASEURL = 'https://ipos.quickxero.com';
  public static NT_ASSETS = 'ipos.quickxero.com/backendpos/assets/';
  public static NT_PAYMENT_METHODS = 'ipos.quickxero.com/backendpos/assets/img/icons/';
  public static NT_ITEM_ASSETS = 'ipos.quickxero.com/backendpos/assets/uploads/items/';
  public static NT_STORE_ASSETS = 'https://ipos.quickxero.com/backendpos/assets/uploads/stores/';
  public static NT_ACCESS_CLIENT = 'NextTotalClient';
  public static NT_ACCESS_SECRET = 'NextToatlSecret';
  public static NT_SASS_URL = 'https://accounts.rectbox.com';
  public static NT_SAAS_BASEURL = 'saasap.rectbox.com:8080/';
  public static NT_SAAS_BILLING_BASEURL = 'billing.rectbox.com:8080/';
  public static NT_SAAS_PRICING_URL = 'signup.upknok.com/signup/pricing/cHJvMDA0/';
  public static NT_STC_PAY_URL = 'https://b2btest.stcpay.com.sa/B2B.MerchantWebApi/Merchant/';
  public static STIMULSOFT_KEY = '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHldxeRaOSLAicxGSHkNXS4CDfusF7v8nvoHRzRUGCJigeK3NK8UbqCMrn15P0uFBzdDM+rVDg6MtEHhYfuewdqJdgBPSfHgtC5vr/Lr7jyoPkzHyz4OwZdzaqeIWSxEci8sbEQpjFEBGb/e0IN6kDD8Hr3tJsjf1OoQsxQNjcGL94TDIp7+IAzLfkIqEkF23IZblF1HYCpegpXykvMBwXuFofUDDvR4wt56NzcFpl8hhysnTkCfzsx1AJSKWKUtqW4TlyOSwQWinBQcdf7novb6Fja6kUfOkfjXVutpWRBf8o56baLrQKqZn9UiovwUyWto7qbST6T6oLDHXV3JEocBTe9TQz0RW79GTgYuttKxtHUMgVUyUIbhYwZjvtur4aCFHM8srJC4mAFms88I90OS72i0mTNRJl0S0co711XZV8pef0aUcV+W40AxTyvjWvCT/rVoYrzVFJVtXLlMb54tnKPPJEJzFgzfn/p4fzP35X9RJsmwPrbLSnUQvCWplImepOVEdLH+2NYxgnSrd5zY';
  public static AMAZON_S3 = 'https://s3.amazonaws.com/upknokpos/';


  // configration for Shafiq Working End

  // public static NT_HTTP_PROTOCOL = 'http';
  // public static NT_HTTP_SEPARATOR = '://';
  // public static NT_API_ENDPOINT = 'posoffline.worrkbox.com/api/';
  // public static NT_LOGIN_LOGO = 'http://posoffline.worrkbox.com/api/assets/login/logo.png';
  // public static NT_PROFILE_PATH = 'posoffline.worrkbox.com/api/assets/user_profile/';
  // public static NT_BASEURL = 'http://posoffline.worrkbox.com';
  // public static NT_ASSETS = 'posoffline.worrkbox.com/api/assets/';
  // public static NT_PAYMENT_METHODS = 'posoffline.worrkbox.com/api/assets/img/icons/';
  // public static NT_ITEM_ASSETS = 'posoffline.worrkbox.com/api/assets/uploads/items/';
  // public static NT_STORE_ASSETS = 'posoffline.worrkbox.com/api/uploads/stores/';
  // public static NT_ACCESS_CLIENT = 'NextTotalClient';
  // public static NT_ACCESS_SECRET = 'NextToatlSecret';
  // public static NT_SASS_URL = 'https://accounts.rectbox.com';
  // public static NT_SAAS_BASEURL = 'saasap.rectbox.com:8080/';
  // public static NT_SAAS_BILLING_BASEURL = 'billing.rectbox.com:8080/';
  // public static NT_SAAS_PRICING_URL = 'signup.upknok.com/signup/pricing/cHJvMDA0/';
  // public static NT_STC_PAY_URL = 'https://b2btest.stcpay.com.sa/B2B.MerchantWebApi/Merchant/';
  // public static STIMULSOFT_KEY = '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHldxeRaOSLAicxGSHkNXS4CDfusF7v8nvoHRzRUGCJigeK3NK8UbqCMrn15P0uFBzdDM+rVDg6MtEHhYfuewdqJdgBPSfHgtC5vr/Lr7jyoPkzHyz4OwZdzaqeIWSxEci8sbEQpjFEBGb/e0IN6kDD8Hr3tJsjf1OoQsxQNjcGL94TDIp7+IAzLfkIqEkF23IZblF1HYCpegpXykvMBwXuFofUDDvR4wt56NzcFpl8hhysnTkCfzsx1AJSKWKUtqW4TlyOSwQWinBQcdf7novb6Fja6kUfOkfjXVutpWRBf8o56baLrQKqZn9UiovwUyWto7qbST6T6oLDHXV3JEocBTe9TQz0RW79GTgYuttKxtHUMgVUyUIbhYwZjvtur4aCFHM8srJC4mAFms88I90OS72i0mTNRJl0S0co711XZV8pef0aUcV+W40AxTyvjWvCT/rVoYrzVFJVtXLlMb54tnKPPJEJzFgzfn/p4fzP35X9RJsmwPrbLSnUQvCWplImepOVEdLH+2NYxgnSrd5zY';
  // public static AMAZON_S3 = 'https://s3.amazonaws.com/upknokpos/';


}
